import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  Button,
  Link as MuiLink
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useContent } from '../contexts/ContentContext';

const Footer = () => {
  const { language, toggleLanguage } = useLanguage();
  const { content } = useContent();
  const t = content[language] || content.ar;

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.default',
        borderTop: 1,
        borderColor: 'divider',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: 'primary.main' }}>
              {t.siteName}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {t.tagline}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              📍 {t.location}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              👤 {t.owner}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {t.nav.services}
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              {t.services?.map((service, index) => (
                <Box component="li" key={index} sx={{ mb: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    {service.title}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {t.nav.contact}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              📞 +966 XX XXX XXXX
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              📧 info@alrasheed.com
            </Typography>
            <Typography variant="body2" color="text.secondary">
              ⭐ {language === 'ar' ? 'تقييم 4.5' : '4.5 Rating'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {language === 'ar' ? 'اللغة' : 'Language'}
            </Typography>
            <Button
              variant="contained"
              onClick={toggleLanguage}
              sx={{ textTransform: 'none' }}
            >
              {language === 'ar' ? 'English' : 'العربية'}
            </Button>
          </Grid>
        </Grid>
        <Box
          sx={{
            borderTop: 1,
            borderColor: 'divider',
            mt: 4,
            pt: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            &copy; {new Date().getFullYear()} {t.siteName}. {language === 'ar' ? 'جميع الحقوق محفوظة' : 'All rights reserved'}.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
